import React from "react";
import Header from "../../../../Components/Header";
import { Helmet } from "react-helmet";
import OpenInvoiceCreation from "./OpenInvoiceCreation";
function CreateInvoiceCreation() {
  return (
    <div className="d-flex flex-column" style={{ minHeight: "100vh" }}>
      <Helmet>
        <title>Opening Invoice Creationhhhh Tool</title>
      </Helmet>
      <Header />
      <div
        className="container-fluid maindiv d-flex flex-column "
        style={{ flexGrow: "1" }}
      >
        <OpenInvoiceCreation />
      </div>
    </div>
  );
}

export default CreateInvoiceCreation;
